import * as Api from '@ViewModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { useErrorMessages } from '../../hooks';
import { ApiClient } from '../../services/api';
import { useStatesOnFetch } from '../utils/useStatesOnFetch';

export const useTranscription = <T>() => {
	const { state, handleWorking, handleResponse, reset } = useStatesOnFetch<T>();

	const userSession = useUserSession();
	const errorMessages = useErrorMessages();

	const client = new ApiClient(userSession);

	const createTranscription = async (phoneCallId: string) => {
		handleWorking();
		try {
			const response = await client.createTranscription(phoneCallId);
			if (!response.success) {
				throw Api.asApiError(response);
			}
			handleResponse(response);
			return response;
		} catch (error) {
			errorMessages.pushApiError(error);
		}
	};

	const getTranscription = async (transcriptionId: string, viewSpeakerLine?: boolean) => {
		handleWorking();
		try {
			const response = await client.getTranscription<T>(transcriptionId, viewSpeakerLine);
			if (!response.success) {
				throw Api.asApiError(response);
			}
			handleResponse(response);
			return response;
		} catch (error) {
			errorMessages.pushApiError(error);
		}
	};

	const markAsRead = async (transcriptionId: string) => {
		handleWorking();
		try {
			const response = await client.markAsRead(transcriptionId);
			if (!response.success) {
				throw Api.asApiError(response);
			}
			handleResponse(response);
			return response;
		} catch (error) {
			errorMessages.pushApiError(error);
		}
	};

	return {
		...state,
		createTranscription,
		empty: !state?.data,
		getTranscription,
		markAsRead,
		reset,
		status: state.status,
	};
};
